import {makeAutoObservable} from "mobx";
import {CustomEvents, eventEmitter} from "../events/events";
import {EventEmitter} from "events";


type PossibleColors = 'success' | 'error' | 'info' | 'warning';


export class GlobalMessageStore {
    message: string = "";
    isOpen: boolean = false;
    color: PossibleColors = 'success';
    eventEmitter: EventEmitter;

    constructor() {
        makeAutoObservable(this);
        this.eventEmitter = eventEmitter.on(CustomEvents.GLOBALMESSAGE, this.onGlobalMessage);
    }

    setMessage = (message: string) => {
        this.message = message;
    }
    setIsOpen = (isOpen: boolean) => {
        this.isOpen = isOpen;
    }
    setColor = (color: PossibleColors) => {
        this.color = color;
    }

    onGlobalMessage = (color: PossibleColors, message: string) => {
        this.setColor(color);
        this.setMessage(message);
        this.setIsOpen(true);
    }
}